//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    display: flex;
    flex-direction: column;
    gap: 15px;
    border-bottom: 1px solid var(--purple-4);
    width: 100%;
    padding-bottom: 25px;
`;
export const DataSection = styled.div`
    & > h5 {
        color: var(--dark-4);
        font-size: 16px;
        font-weight: bold;
        margin: 0;
        margin-bottom: 8px;
    }
    & > div {
        display: flex;
        gap: 12px;
        align-items: center;
        & svg {
            fill: var(--purple-6);
        }
        & a {
            color: var(--green-2);
            text-decoration-thickness: 2px;
            font-size: 14px;
            font-weight: bold;
        }
    }
`;